export default {
  shop: {
    id: 'nav_services_shop',
    defaultMessage: 'Shop',
  },
}
